import { defineStore } from 'pinia'

import { useAppStore } from '@/store'

import type { ClientOrderParams } from '@/api/pay'

import { WEBVIEW, MINI_PROGRAM, NEED_SECURITY_AUTHENTICATE } from '@/constant'

// export interface OrderParams {
//   subject: string;
//   orderSrc: string;
//   sign: string;
//   remark: string;
//   body: string;
//   mcc: string;
//   notify_url: string;
//   enable_pay_channels: string;
//   out_trade_no: string;
//   total_amount: string;
//   subMcc: string;
//   timeout_express: string;
//   disable_pay_channels: string;
//   subMerName: string;
//   subMerNo: string;
// }

export interface PreOrder {
  appId: number
  orderParamStr: string
}

interface WebviewState {
  /**
   * 订单参数
   * - 澳觅APP直接传递
   * - 小程序和H5是从url中获取拆离的订单参数 然后重新拼接起来的
   */
  preOrder: PreOrder
  /** 生成订单所需的参数 */
  generateOrderParams: ClientOrderParams
  /** webview类型 澳觅APP 微信小程序 支付宝小程序 */
  webviewType: string
  /** 订单ID 用于小程序场景 小程序支付完成后跳转使用 */
  orderId: string
  /** 重定向地址 用于支付成功后重定向 */
  redirectUrl: string
}

export const useWebviewStore = defineStore({
  id: 'webview',
  state: (): WebviewState => ({
    preOrder: {} as PreOrder, //
    generateOrderParams: {} as ClientOrderParams, // 生成订单所需参数
    webviewType: WEBVIEW.APP, // webview类型 app,H5,微信小程序，支付宝小程序
    orderId: '', // 订单id 用于小程序场景
    redirectUrl: '',
  }),

  getters: {
    isFromH5: (state) => WEBVIEW.H5 === state.webviewType,
    isWechatMiniProgram: (state) => WEBVIEW.WECHAT_MINI_PROGRAM === state.webviewType,
    isAliPayMiniProgram: (state) => WEBVIEW.ALI_PAY_MINI_PROGRAM === state.webviewType,
    isFromMiniProgram: (state) => MINI_PROGRAM.includes(state.webviewType),
    isNeedValidateDevice(state): boolean {
      return NEED_SECURITY_AUTHENTICATE.includes(state.webviewType) && !useAppStore().tempKey
    },
  },

  actions: {
    // setGenerateOrderParams(preOrder: string) {
    //   this.preOrder = JSON.parse(preOrder);
    //   const tradeNo = this.preOrder.trade_no || this.preOrder.tradeNo;
    //   if (tradeNo) {
    //     useAppStore().tradeNo = tradeNo;
    //   } else {
    //     this.generateOrderParams = {
    //       appId: this.preOrder.appId,
    //       bizContent: JSON.stringify(this.preOrder.orderParamStr),
    //     };
    //   }
    // },
  },

  persist: {
    enabled: true,
    // strategies: [
    //   {
    //     key: 'my_user',
    //     storage: localStorage,
    //   },
    // ],
  },
})
